import { useTracking } from 'react-tracking';

import ChevronRightSmallSolid from '@simplywallst/ui-core/icons/ChevronRightSmallSolid';
import { Grid, Text, useTheme } from '@simplywallst/ui-core';

import { FooterButton } from './styled';

interface Props {
  canonicalURL: string;
}

const FullAnalysisLink = ({ canonicalURL }: Props) => {
  const theme = useTheme();
  const { trackEvent } = useTracking();
  return (
    <FooterButton
      data-cy-id="monitoring-panel-footer-link"
      to={canonicalURL}
      onClick={() =>
        trackEvent({
          modifier: 'FooterLink',
          action: 'click',
          canonicalURL,
        })
      }
    >
      <Grid templateColumns="max-content auto" alignItems="center">
        <Text typography="xSmall">Full Analysis</Text>
        <ChevronRightSmallSolid fill={theme.color.whiteRGBA(0.5)} />
      </Grid>
    </FooterButton>
  );
};

export default FullAnalysisLink;
